import { makeStyles } from "@material-ui/core";
import React from "react";

let useStyles = makeStyles(() => ({
    root: {
        width: 102,
        height: 98,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        flexDirection:'column',
        backgroundColor:'rgba(238,238,248,1)',
        margin:5,
        borderRadius:10,
        '@media (max-width:460px)': {
            margin:10,
        },
        '@media (max-width:445px)': {
            width: 102,
            height: 98,
            maxWidth:'100%',
          },
    },
    link:{
        width: 102,
        height: 170,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        flexDirection:'column',
    },
    gridIcons: {
        width:100,
        height:100,
        borderRadius: '100%',
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        backgroundColor:'rgba(231,227,242,1)',
    },
    icon:{
        width:'60%',
        height:56,
    },
    content:{
        textAlign:'center',
        marginTop:20,
        color:'white'
    }
}))

export default function Index({ data }) {

    let classes = useStyles();

    return (
        <a  target={'_blank'} href={data?.link} className={classes['link']}>
        <div className={classes['root']}>
            <div className={classes['gridIcons']}>
                <img className={classes['icon']} src={data?.icon} alt={data?.title  + data?.desc} />
            </div>
        </div>
            <div className={classes['content']}>
                <h6>
                    {data?.title}
                </h6>
                {/* <h6>
                    {data?.desc}
                </h6> */}
            </div>
        </a>
    );
}
